import { lazy } from 'react';

export default lazy(() =>
  import(/* webpackChunkName: 'part_library' */ './PartLibraryPage'),
);
